import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import FeeTextPopup from 'apps/auth/components/common/send/popups/FeeTextPopup';
import PreCheckRow from 'apps/auth/components/common/send/popups/Precheck/PreCheckRow';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_GA_LIBRE_SIGN_TERMS } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import { HAVE_BANK_ACCOUNT } from './LibreHistoryScreenConstants';
import ActivityIcon from '../../components/ActivityIcon';

const Terms = styled.div`
    a.link:link,
    a.link:visited {
        text-decoration: none;
        color: ${(props) => props.theme.black};
    }
`;

const LibreTermsPopup = ({ popupRef = null, ...props }) => {
    const messages = usePageMessages();

    const renderTransactionInfo = () => (
        <>
            <Row indent="adaptive-16-24">
                <ActivityIcon item={props.item} options={props.options} flagName="paysend" />
            </Row>
            <Text variant="div" indent="4px">
                {resolveArguments(messages.fromRecipient, props.item.extra.sender_first_name + ' ' + props.item.extra.sender_last_name)}
            </Text>
            <Text variant="div" size="display2" indent="adaptive-32-48">
                {props.item.toAmtReal}
                <Text size="display2" smallCaps leftSpacer>
                    {props.item.mobileInfo.toCurIso.toLowerCase()}
                </Text>
            </Text>
        </>
    );

    const onPrimaryButtonClick = (e) => {
        props.doRequest(e, AUTH_GA_LIBRE_SIGN_TERMS, null, () => {
            props.updateExtraByName('needToSignTerms', false);
            popupRef.current?.close();
            props.setScreen(HAVE_BANK_ACCOUNT);
            props.toggleSpinner(false);
        });
    };

    return (
        <ComplexPopup textCenter primaryButtonText={messages.confirmAndReceive} onPrimaryButtonClick={onPrimaryButtonClick} withoutCloseButton>
            {renderTransactionInfo()}
            <TableContainer indent="48px">
                <PreCheckRow
                    title={messages.toBlock}
                    text={
                        <>
                            {messages.transferPaysend}
                            <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                        </>
                    }
                    onClick={() => {
                        popupRef.current?.open(<FeeTextPopup text={messages.transferPaysendInfo} closeHandler={props.openLibreTermsPopup} />);
                    }}
                />
            </TableContainer>

            <Terms>
                <DangerouslyHtml variant="div" type="text" size="secondary" color="secondary" dangerouslyHtml={messages.libreTerms} />
            </Terms>
        </ComplexPopup>
    );
};

LibreTermsPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { updateExtraByName, toggleSpinner })(LibreTermsPopup);
